import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    public title: string = '¡Bienvenido a la web del campus ICAI-ICADE!';

    public studentsTitle   : string = 'Participantes';
    public studentsText    : string = 'El primer paso es dar de alta a l@s alumn@s que van a participar en el campus.';
    public studentsUrl     : string = '/participantes';
    public enrollmentsTitle: string = 'Inscripciones';
    public enrollmentsText : string = 'Desde esta opción puede crear una inscripción por participante y campus en el/los cursos que desee. También puede revisar las inscripciones ya creadas.';
    public enrollmentsUrl  : string = '/inscripciones';
    public profileTitle    : string = 'Mi perfil';
    public profileText     : string = 'Desde aquí puede revisar y editar sus datos de contacto así como cambiar su contraseña.';
    public profileUrl      : string = '/tutor';

    constructor(public router: Router) { }

    ngOnInit(): void { }

}
